module.exports = __webpack_public_path__ + "img/enoshima.0e608c68.png";